import React from 'react';
import { UserCircle } from 'lucide-react';
export function CustomerLogin() {
  return <div className="mt-12 bg-white border-2 border-brand-darkGold rounded-lg p-6 max-w-md" data-id="element-149" data-mp="1x37yx2rz44bb">
      <div className="flex items-center gap-2 mb-4" data-id="element-150" data-mp="21uhl1tebcpig">
        <UserCircle className="w-5 h-5 text-gray-500" data-id="element-151" data-mp="21upybmeclwu6" />
        <h3 className="text-lg font-bold text-brand-charcoal" data-id="element-152" data-mp="26tu7id19vuki">
          Return customers log in here.
        </h3>
      </div>

      <form className="space-y-4" onSubmit={e => e.preventDefault()} data-id="element-153" data-mp="196u4cpg5yj13">
        <div data-id="element-154" data-mp="1e43rfyg2yilr">
          <label htmlFor="email" className="sr-only" data-id="element-155" data-mp="1e5omdp6b43k5">
            Email
          </label>
          <input type="email" id="email" placeholder="Email" className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:border-brand-darkGold focus:ring-1 focus:ring-brand-darkGold" data-id="element-156" data-mp="1j3gnn9sud210" />
        </div>
        <div data-id="element-157" data-mp="2zhgl8e47sfl3">
          <label htmlFor="password" className="sr-only" data-id="element-158" data-mp="2zh6rcfg1toa4">
            Password
          </label>
          <input type="password" id="password" placeholder="Password" className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:border-brand-darkGold focus:ring-1 focus:ring-brand-darkGold" data-id="element-159" data-mp="1xx5ow68fucal" />
        </div>
        <div className="flex items-center gap-3" data-id="element-160" data-mp="1jxxl101byg02">
          <button type="submit" className="bg-brand-lightGold hover:bg-brand-darkGold border border-brand-darkGold text-black font-semibold px-6 py-2 rounded text-sm transition-colors" data-id="element-161" data-mp="1jz8muub7tdoj">
            Log In
          </button>
          <button type="button" className="bg-brand-lightGold hover:bg-brand-darkGold border border-brand-darkGold text-black font-semibold px-6 py-2 rounded text-sm transition-colors" data-id="element-162" data-mp="1599r0y74uec8">
            Find Pass
          </button>
        </div>
      </form>
    </div>;
}